import React, { useState } from "react";

export const useEditMode = () => {
  const [edit, setEdit] = useState(false);

  const toggleEditMode = (e: React.ChangeEvent<HTMLInputElement>) =>
    setEdit(!edit);
  
  return { edit, toggleEditMode, setEdit }
}